/* ==========================================================================
   FTB - current page nav state
   Added 2026-08-24. Styling lives in assets/ftb-interaction.css.

   WHY THIS EXISTS: measured on the draft theme, .navlink--toplevel carried no
   aria-current and no active/current class of any kind. The only element on
   the home page with aria-current was the country selector in the footer.
   Broadcast simply does not mark the current page in the nav, so the state
   has to be created before it can be styled.

   HOW IT MATCHES, measured from the real menu:

     Shop         6 links, all /collections/...
     Collections 13 links, all /collections/...
     The Vault    1 link  /pages/vault
     News         1 link  /blogs/news
     Events       1 link  /pages/events
     Tours        1 link  /pages/tours
     Radio        1 link  /pages/bronx-radio
     Press        1 link  /pages/press

   Every anchor inside a top-level <li class="menu__item"> is considered, not
   just the top-level anchor itself. That is what makes a nested route light
   the right parent: /collections/bronxapparel lights Shop, and a blog article
   at /blogs/news/<handle> prefix-matches /blogs/news and lights News.

   LONGEST MATCH WINS, so a link deeper in a submenu beats a shorter one that
   also prefix-matches. A trailing slash is stripped from both sides first.

   THE EXACT match gets aria-current="page"; the top-level item that contains
   it gets aria-current="true". Two different values on purpose - ARIA expects
   at most one "page" per navigation, and "true" is the correct value for an
   ancestor that merely contains the current item.

   WHAT IT DELIBERATELY DOES NOT DO
     - The home page lights nothing. There is no Home item in the nav; the
       logo is the home link. "/" is skipped rather than matched.
     - Product pages at /products/<handle> light nothing. A product URL on
       Shopify carries no collection, so there is no honest way to decide
       whether it belongs to Shop or to Collections without hardcoding a map
       the owner would then have to maintain. Flagged rather than guessed.
     - The mobile drawer is not touched. Its rows are SPAN.sliderow__title
       inside BUTTON elements with no href, so there is nothing to match a
       pathname against. That needs its own measurement at 390px.

   It sets one attribute and reads nothing else. It cannot affect cart,
   checkout, or any Broadcast behaviour.
   ========================================================================== */
(function () {
  var d = document;

  function norm(u) {
    try {
      return new URL(u, location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (err) {
      return null;
    }
  }

  function mark() {
    var path = norm(location.pathname);
    if (!path || path === '/') return;

    var best = null;      /* the top-level .navlink to light */
    var bestLen = -1;
    var exact = null;     /* the anchor whose path matches exactly */

    var items = d.querySelectorAll('.menu__item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var top = li.querySelector('.navlink--toplevel');
      if (!top) continue;

      var links = li.querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) {
        var p = norm(links[j].getAttribute('href'));
        if (!p || p === '/') continue;

        /* Exact, or a genuine path segment below it. The trailing slash in
           the prefix test stops /pages/press matching /pages/press-kit. */
        var hit = (path === p) || (path.indexOf(p + '/') === 0);
        if (!hit) continue;

        if (path === p && !exact) exact = links[j];
        if (p.length > bestLen) { bestLen = p.length; best = top; }
      }
    }

    if (exact && exact !== best) exact.setAttribute('aria-current', 'page');
    if (best) best.setAttribute('aria-current', exact === best ? 'page' : 'true');
  }

  if (d.readyState !== 'loading') { mark(); }
  else { d.addEventListener('DOMContentLoaded', mark); }
})();
